<div class="w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">
        Gérer les options d'une ligne
    </div>
</div>

@if (line && (line.status.toLowerCase() == 'active' || line.statusCode == 'PARTIAL_SUSPENSION') && selectedOfferDetails) {
    <section>
        @if (selectedOfferDetails) {
            <div class="grid">
                @for (option of selectedOfferDetails.options_fmt.stand_alone_options; track option; let index = $index) {
                    <div>
                        @if (option.show_on_change_options == true && option.requirement !== 'mandatory') {
                            <p class="mt-2">
                                <label [for]="'option' + index ">
                                    <input
                                            type="checkbox"
                                            name="option"
                                            [id]="'option' + index "
                                            [value]="option.label_ec"
                                            [checked]="isSelected(option.option_id) || (option.group_label && option.group_label.toLowerCase() === 'promo')"
                                            [disabled]="option.group_label && option.group_label.toLowerCase() === 'promo'"
                                            (click)="setSelectedOptions($event, option.option_id, option.label_ec, null, null)"
                                    />
                                    <span class="option-label">{{ option.label_ec }}</span>
                                    <span class="bold-text">
                    {{ option.in_sale_ttc.toFixed(2).replace('.', ',') }} €
                  </span>
                                </label>
                            </p>
                        }
                    </div>
                }
                @for (optionGroups of selectedOfferDetails.options_fmt.option_groups; track optionGroups; let index = $index) {
                    <div>
                        @if (showOptionsGroup(selectedOfferDetails.options_fmt.option_groups, optionGroups.id)) {
                            <div class="pb-1 pt-2">
                                {{ optionGroups.label }}
                                @if (optionGroups.requirements === 'mandatory') {
                                    <span class="bold-red-text">*</span>
                                }
                            </div>
                        }
                        @if (showOptionsGroup(selectedOfferDetails.options_fmt.option_groups, optionGroups.id)) {
                            <div>
                                @for (option of optionGroups.options; track option) {
                                    <p class="group-options">
                                        <label [for]="'option' + index ">
                                            <input
                                                    type="radio"
                                                    [name]="optionGroups.label"
                                                    [id]="'option' + index "
                                                    [value]="option.label_ec"
                                                    [checked]="isSelected(option.option_id)"
                                                    (click)="setSelectedOptions($event, option.option_id, option.label_ec, optionGroups.id, optionGroups.label)"
                                            />
                                            <span class="option-label">{{ option.label_ec }}</span>
                                            <span class="bold-text">
                        {{ option.in_sale_ttc.toFixed(2).replace('.', ',') }} €
                      </span>
                                        </label>
                                    </p>
                                }
                            </div>
                        }
                        @if ((optionGroups.label.toLowerCase() == suisseOption.toLowerCase() && endDateSuisseOption) || (optionGroups.label.toLowerCase() == tripOption.toLowerCase() && endDateVoyageOption)) {
                            <div>
                                <label>
                                    Ajouter une date
                                </label>
                                @if (optionGroups.label.toLowerCase() == suisseOption.toLowerCase()) {
                                    <div>
                                        <input type="text" class="form-control mb-2" placeholder="jj/mm/aaaa"
                                               [(ngModel)]="endDateSuisse">
                                        @if (errorMessageSuisse != null) {
                                            <div>
                                                <div class="error-message">
                                                    {{ errorMessageSuisse }}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                @if (optionGroups.label.toLowerCase() == tripOption.toLowerCase()) {
                                    <div>
                                        <input type="text" class="form-control mb-2" placeholder="jj/mm/aaaa"
                                               [(ngModel)]="endDateVoyage">
                                        @if (errorMessageVoyage != null) {
                                            <div>
                                                <div class="error-message">
                                                    {{ errorMessageVoyage }}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
        @if (submitted && invalidOptions) {
            <p class="error-msg">
                Merci de cocher les options obligatoires.
            </p>
        }
    </section>
}

@if (line.status.toLowerCase() !== 'active' && line.statusCode !== 'PARTIAL_SUSPENSION') {
    <div class="mt-5">
        <div class="w-100 text-center proc-buttons">
            <div>Pour activer ou désactiver les options, La ligne doit être active.</div>
        </div>
    </div>
}

<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        @if (line && line.status.toLowerCase() == 'active') {
            <button type="submit" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
        }
    </div>
</div>

